module.exports = __webpack_public_path__ + "img/right_tc.58ec6482.png";